<div [attr.data-tooltip-text]="'blocks.ineligible.' + mode | transloco"
     data-tooltip-position="top"></div>
